// Google Analytics / GTM service

// We push directly to window.dataLayer instead of calling window.gtag() to avoid a race
// condition where GTM hasn't finished loading yet. window.dataLayer is initialised
// synchronously by the GTM snippet before any scripts load, so pushes made here are
// queued and processed in order once the GTM container is ready.
// See: https://developers.google.com/tag-manager/devguide#datalayer
const track = (event, params) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (error) {
    console.error('[BFT Google] Tracking failed:', error);
  }
};

export const trackSearch = (searchTerm) =>
  track('search', { search_term: searchTerm });

export const trackViewItem = ({
  item_id,
  item_name,
  price,
  currency,
  item_brand,
  item_category,
}) =>
  track('view_item', {
    currency,
    value: price || 0,
    items: [
      { item_id, item_name, item_brand, item_category, price, quantity: 1 },
    ],
  });

export const trackAddToCart = ({
  item_id,
  item_name,
  price,
  quantity,
  currency,
}) =>
  track('add_to_cart', {
    currency,
    value: (price || 0) * quantity,
    items: [{ item_id, item_name, price, quantity }],
  });

export const trackBeginCheckout = ({ items, value, currency }) =>
  track('begin_checkout', { currency, value, items });

export const trackPurchase = ({
  transaction_id,
  items,
  value,
  currency,
  tax,
  shipping,
  user_data,
}) => {
  if (user_data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'set', user_data });
  }

  const purchasePayload = {
    transaction_id,
    value,
    tax,
    shipping,
    currency,
    items,
  };

  if (user_data?.email) {
    purchasePayload.email = user_data.email;
  }

  track('purchase', purchasePayload);
};
